import useScheduleHook from "@/shared/hooks/useScheduleHook";
import { useMemo } from "react";

const useSchedule = (accountId= -1) => {
  const { data } = useScheduleHook();
  return useMemo(() => {
    if (data && accountId) {
      return data.find((s) => parseInt(`${s.account_id}`) === accountId);
    }
    return undefined;
  }, [data,accountId]);
};

export default useSchedule;
